import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { combineReducers } from "redux";

import { user } from "../db/User";
import { view } from "../db/View";
import { data } from "../db/data";
import { drivers } from "../db/drivers";
import { translate } from "../db/Translate";
import { language } from "../db/Language";
import { search } from "../db/search";
import { cart } from "../db/Cart";
import { ex } from "../db/Ex";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const storage = createStore(combineReducers({
	user, view, data, drivers, language, translate, search, cart, ex
}), composeEnhancers(
	applyMiddleware(thunk)
));

export const t = (key) => {
	const state = storage.getState();

	if (state.translate.find(el => String(el.key) === String(key))) {
		return state.translate.find(el => String(el.key) === String(key)).value;
	}

	return ''
};
export default storage;